import React, { useEffect, useState } from "react";
import { Table, Spin } from "antd";
import { useSelector } from "react-redux";
import { capitalizeWords, addZeroes, getLatestUpdated } from "../Components/CommonFunction";
import moment from "moment";

const CANVAS_WIDTH = 1920;
const CANVAS_HEIGHT = 1080;
const UPDATED_LINE_HEIGHT = 60;
const HEADER_ROW_HEIGHT = 80;
const HEADER_FONT_SIZE = 51;
const UPDATED_FONT_SIZE = 40;
const MAX_BODY_FONT_SIZE = 80;

const TableData3 = () => {
  const reduxData = useSelector((state) => state.MetalDataReducer.data);
  const [data, setData] = useState([]);
  const [scale, setScale] = useState(1);
  const [canvasHeight, setCanvasHeight] = useState(CANVAS_HEIGHT);

  useEffect(() => {
    const filteredData = reduxData.filter((item) => item.product_name !== "Gold 23" && item.product_name !== "Gold 23.5");
    setData(filteredData);
  }, [reduxData]);

  useEffect(() => {
    const fitToScreen = () => {
      const nextScale = window.innerWidth / CANVAS_WIDTH;
      setScale(nextScale);
      setCanvasHeight(window.innerHeight / nextScale);
    };

    fitToScreen();
    window.addEventListener("resize", fitToScreen);
    window.addEventListener("orientationchange", fitToScreen);
    return () => {
      window.removeEventListener("resize", fitToScreen);
      window.removeEventListener("orientationchange", fitToScreen);
    };
  }, []);

  const tableHeight = canvasHeight - UPDATED_LINE_HEIGHT;
  const rowHeight = (tableHeight - 2 * HEADER_ROW_HEIGHT) / Math.max(data.length, 1);

  const headerCellStyle = { fontWeight: "bold", fontSize: `${HEADER_FONT_SIZE}px` };
  const bodyCellStyle = {
    fontWeight: "bold",
    fontSize: `${Math.max(Math.min(MAX_BODY_FONT_SIZE, rowHeight * 0.62), 12).toFixed(1)}px`,
  };

  const columns = [
    {
      title: <span style={headerCellStyle}>Metal Type</span>,
      dataIndex: "product_name",
      key: "product_name",
      align: "center",
      width: "30%",
      render: (text, record) => (
        <span style={bodyCellStyle}>
          {record.product_name === "Silver 0" ? (
            "Silver Article"
          ) : record.product_name === "silver 100" ? (
            "Silver Bar"
          ) : (
            <>{text}</>
          )}
        </span>
      ),
    },
    {
      title: <span style={headerCellStyle}>Rate</span>,
      align: "center",
      children: [
        {
          title: <span style={headerCellStyle}>Sale Per gram</span>,
          dataIndex: "sale_amount",
          key: "sale_amount",
          align: "center",
          width: "35%",
          render: (text, record) => (
            <span style={bodyCellStyle}>
              {text == null ? (
                "-"
              ) : (
                <>
                  {"₹"}
                  {addZeroes(text)}
                </>
              )}
            </span>
          ),
        },
        {
          title: <span style={headerCellStyle}>Purchase Per gram</span>,
          dataIndex: "purchase_amount",
          key: "purchase_amount",
          align: "center",
          width: "35%",
          render: (text, record) => (
            <span style={bodyCellStyle}>
              {text == null ? (
                "-"
              ) : (
                <>
                  {"₹"}
                  {addZeroes(text)}
                </>
              )}
            </span>
          ),
        },
      ],
    },
  ];

  const latestUpdated = getLatestUpdated(data);

  return (
    <div className="gss-tabledata-viewport">
      <div
        className="gss-tabledata-canvas"
        style={{
          width: `${CANVAS_WIDTH}px`,
          height: `${canvasHeight}px`,
          transform: `scale(${scale})`,
          "--gss-table-height": `${tableHeight}px`,
        }}
      >
        <div
          style={{
            height: `${UPDATED_LINE_HEIGHT}px`,
            paddingRight: "20px",
            textAlign: "right",
            fontWeight: "bold",
            fontSize: `${UPDATED_FONT_SIZE}px`,
          }}
        >
          Updated On: {latestUpdated ? moment(latestUpdated.updated).format("YYYY-MM-DD hh:mm:ss A"): "-"}
        </div>

        <Table
          columns={columns}
          dataSource={data}
          size="small"
          sorter={true}
          pagination={false}
          tableLayout="fixed"
          bordered
        />
      </div>
    </div>
  );
};

export default TableData3;
